module.exports = __webpack_public_path__ + "img/3-2.f316a5b6.jpg";